import { Helmet } from 'react-helmet';
import type { Product } from '../../bff-api/products/model';

export const ProductSchema = ({ product }: { product?: Product }) => {
    if (product) {
        const { c_productSchema } = product;

        if (c_productSchema) {
            return (
                <Helmet>
                    <script type="application/ld+json" data-testid="product-schema">
                        {JSON.stringify(c_productSchema, null, 2)}
                    </script>
                </Helmet>
            );
        }
    }

    return null;
};
